import { Box, type SxProps, styled, type Theme } from "@mui/material";
import type { FC } from "react";
import { useHospitalData } from "../../../contexts/HospitalDataProvider";
import { useRoleColors, useRoleGroupColors } from "../../../hooks/useRoleColors";
import { INK_BLACK } from "../../../theme/tokens";
import type { NurseFullRole } from "../../../utils/models";
import { getShortRole, roleShortStringToEnumFullRole } from "../../../utils/utilFunctions";

type Props = {
	role?: NurseFullRole | string;
	roleGroup?: string;
	/** Optional style override (e.g. a pill `borderRadius`); merged onto the default role container. */
	sx?: SxProps<Theme>;
};
interface RoleContainerProps {
	fill: string;
}

const RoleContainer = styled(Box, {
	shouldForwardProp: (propName) => propName !== "fill",
})<RoleContainerProps>(({ fill }) => ({
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	minWidth: 40,
	width: "fit-content",
	paddingInline: 4,
	height: 18,
	borderRadius: "4px",
	color: INK_BLACK /*todo introduce this color to the palate (?)*/,
	backgroundColor: fill,
	fontSize: "13px",
	fontWeight: 500,
	lineHeight: "13px",
}));

/**
 * A general purpose role container to be used to represent the role.
 */
const ColorfulRole: FC<Props> = ({ role, roleGroup, sx }) => {
	const roleColor = useRoleColors();
	const roleGroupColor = useRoleGroupColors();
	const { chosenDepartment } = useHospitalData();
	const actualRole = typeof role === "string" ? (roleShortStringToEnumFullRole(role) ?? (role as NurseFullRole)) : role;

	if (!actualRole && !roleGroup) {
		return null;
	}

	return (
		<RoleContainer fill={actualRole ? roleColor(actualRole).fill : roleGroupColor(roleGroup ?? "", chosenDepartment.role_groups).fill} sx={sx}>
			{roleGroup ? roleGroup : getShortRole(actualRole as NurseFullRole)}
		</RoleContainer>
	);
};

export default ColorfulRole;
